export function isSessionActiveFunc(adoptClientRestriction) {
    if (!adoptClientRestriction) return false
    const start = new Date(adoptClientRestriction?.start)
    const end = new Date(adoptClientRestriction?.end)
    const now = new Date()
    return end >= now && start <= now
}
